import _extends from "@babel/runtime/helpers/extends";
import Button, { ButtonGroup } from '@atlaskit/button';
import LoadingButton from '@atlaskit/button/loading-button';
import Form, { Field, FormFooter, FormSection, HelperMessage } from '@atlaskit/form';
import TextArea from '@atlaskit/textarea';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import React, { useState } from 'react';
import { MANAGE_PARTNER_DETAILS_VIEW, SUBMIT_ABOUT_PARTNER_FORM } from "../../../../analytics/Events";
import ImageSelectionContainer from "./ImageSelectionContainer/ImageSelectionContainer";

const AboutPartnerForm = props => {
  var _props$_links, _props$_links$logo;

  const [newLogoHref, setNewLogoHref] = useState((_props$_links = props._links) === null || _props$_links === void 0 ? void 0 : (_props$_links$logo = _props$_links.logo) === null || _props$_links$logo === void 0 ? void 0 : _props$_links$logo.href);

  const resetForm = () => {
    var _props$_links2, _props$_links2$logo;

    setNewLogoHref((_props$_links2 = props._links) === null || _props$_links2 === void 0 ? void 0 : (_props$_links2$logo = _props$_links2.logo) === null || _props$_links2$logo === void 0 ? void 0 : _props$_links2$logo.href);
  };

  const fireAnalyticsEvent = useAnalyticsEvents();

  const trackFormSubmission = () => fireAnalyticsEvent({
    eventType: ButtonClickedEvent,
    eventContainer: MANAGE_PARTNER_DETAILS_VIEW,
    actionSubjectId: SUBMIT_ABOUT_PARTNER_FORM
  });

  const onSubmit = data => {
    props.onSubmit({
      description: data.description,
      logoUrl: newLogoHref
    });
  };

  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, ({
    formProps,
    dirty
  }) => {
    var _props$_links3, _props$_links3$logo;

    return /*#__PURE__*/React.createElement("form", formProps, /*#__PURE__*/React.createElement(FormSection, null, /*#__PURE__*/React.createElement(ImageSelectionContainer, {
      iconUrl: props.iconUrl,
      mpacBaseUrl: props.mpacBaseUrl,
      setHref: setNewLogoHref
    }), /*#__PURE__*/React.createElement(Field, {
      label: "Description",
      name: "description"
    }, ({
      fieldProps
    }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextArea, _extends({
      minimumRows: 8,
      defaultValue: props.description || '',
      placeholder: "Describe your organization in 750 characters or less. This description is displayed on your vendor page in the Marketplace."
    }, fieldProps)), /*#__PURE__*/React.createElement(HelperMessage, null, "Describe your organization in 750 characters or less. This description is displayed on your vendor page in the Marketplacee")))), /*#__PURE__*/React.createElement(FormFooter, {
      align: "start"
    }, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(LoadingButton, {
      type: "submit",
      appearance: "primary",
      isDisabled: !dirty && ((_props$_links3 = props._links) === null || _props$_links3 === void 0 ? void 0 : (_props$_links3$logo = _props$_links3.logo) === null || _props$_links3$logo === void 0 ? void 0 : _props$_links3$logo.href) === newLogoHref,
      isLoading: props.submitting,
      onClick: trackFormSubmission
    }, "Save"), /*#__PURE__*/React.createElement(Button, {
      onClick: () => {
        resetForm();
        props.onClose();
      },
      appearance: "subtle"
    }, "Cancel"))));
  });
};

export default AboutPartnerForm;